/**
 * Author : wang885298.
 * Date   : 2019/8/16.
 * File   : Statistics.
 */
import post from '../post/post-proxy'
export default {
  /**
   * /ygst/year/list/get 获取年份列表
   * @param orgId
   */
  yearListGet: orgId => post('swaggerSB', '/ygst/year/list/get', {orgId}),
  /**
   * /ygst/exception/today/handle/info/get 获取今日异常处置未处置统计信息（今日、年份）
   * @param departmentId
   * @param orgId
   * @param year
   */
  handleInfoGet: ({departmentId, orgId, year}) => {
    let params = {
      orgId: orgId
    }
    if (departmentId) {
      params.departmentId = departmentId
    }
    if (year) {
      params.year = year
    }
    return post('swaggerSB', '/ygst/exception/today/handle/info/get', params)
  },
  /**
   * /ygst/device/electric/year/get 年耗电量
   * @param year
   * @param orgId
   */
  electricYearGet: ({year, orgId}) => {
    let params = {
      orgId,
      year
    }
    return post('swaggerSB', '/ygst/device/electric/year/get', params)
  },
  /**
   * /ygst/device/water/year/get 年耗水量
   * @param year
   * @param orgId
   */
  waterYearGet: ({year, orgId}) => {
    let params = {
      year: year,
      orgId: orgId
    }
    return post('swaggerSB', '/ygst/device/water/year/get', params)
  },
  /**
   * /ygst/exception/type/month/group/get 按照月份分类统计异常数据(年份)
   * @param orgId
   * @param year
   */
  exceptionTypeMonthGroupGet: ({orgId, year}) => {
    let params = {
      orgId,
      year
    }
    return post('swaggerSB', '/ygst/exception/type/month/group/get', params)
  },
  /**
   * /ygst/exception/type/dept/group/get 按照食堂分类统计异常数据（年份）
   * @param orgId
   * @param year
   */
  typeDeptGroupGet: ({orgId, year}) => {
    let params = {
      orgId,
      year
    }
    return post('swaggerSB', '/ygst/exception/type/dept/group/get', params)
  },
  /**
   * /ygst/exception/type/anomalousType/group/get 获取异常分类统计信息（今日、年份）
   * @param departmentId
   * @param year
   * @param orgId
   */
  anomalousTypeGroupGet: ({departmentId, year, orgId}) => {
    let params = {}
    if (departmentId) {
      params.departmentId = departmentId
    }
    if (year) {
      params.year = year
    }
    if (orgId) {
      params.orgId = orgId
    }
    return post('swaggerSB', '/ygst/exception/type/anomalousType/group/get', params)
  },
  /**
   * /ygst/exception/nogoodtype/list 报表数据中心-异常类别分类(图标)（无食品）（wzp）
   * @param departmentId
   * @param year
   * @param orgId
   */
  nogoodtypeList: ({departmentId, year, orgId}) => {
    let params = {}
    if (departmentId) {
      params.departmentId = departmentId
    }
    if (year) {
      params.year = year
    }
    if (orgId) {
      params.orgId = orgId
    }
    return post('swaggerSB', '/ygst/exception/nogoodtype/list', params)
  },
  /**
   * /ygst/count/food/in/year/depart/get 根据年份统计各食堂采购信息(liurl)
   * @param year
   * @param orgId
   */
  countFoodInYearDepartGet: ({year, orgId}) => {
    let params = {
      year,
      orgId
    }
    return post('swagger', '/ygst/count/food/in/year/depart/get', params)
  },
  /**
   * /ygst/count/food/in/year/get 根据年份统计食材消耗信息(liurl)
   * @param year
   * @param orgId
   */
  countFoodInYearGet: ({year, orgId}) => {
    let params = {
      year: year,
      orgId: orgId
    }
    return post('swagger', '/ygst/count/food/in/year/get', params)
  },
  /**
   * /ygst/count/food/out/year/get 根据年份统计食品类别出库信息(liurl)
   * @param year
   * @param orgId
   */
  countFoodOutYearGet: ({year, orgId}) => {
    let params = {
      orgId: orgId,
      year: year
    }
    return post('swagger', '/ygst/count/food/out/year/get', params)
  },
  /**
   * /ygst/count/food/out/year/month/get 根据年份统计食品出库月度信息(liurl)
   * @param year
   * @param orgId
   */
  countFoodOutYearMonthGet: ({year, orgId}) => {
    let params = {
      orgId: orgId,
      year: year
    }
    return post('swagger', '/ygst/count/food/out/year/month/get', params)
  },
  /**
   * /ygst/canteenRource/yearAndOrg/get 根据组织ID和年份获取食堂资源统计信息(wzp)
   * @param year
   * @param orgId
   */
  yearAndOrgGet: ({year, orgId}) => {
    let params = {
      year,
      orgId
    }
    return post('swagger', '/ygst/canteenRource/yearAndOrg/get', params)
  },
  /**
   * /ygst/pc/exception/months/trend/get 月度异常趋势
   * @param year
   * @param orgId
   */
  exMonthsTrendGet: ({year, orgId}) => {
    let params = {
      year,
      orgId
    }
    return post('swaggerSB', '/ygst/pc/exception/months/trend/get', params)
  },
  /**
   * /ygst/pc/exception/year/count/get 年度异常统计
   * @param year
   * @param orgId
   */
  exceptionYearCountGet: ({year, orgId}) => {
    let params = {
      year,
      orgId
    }
    return post('swaggerSB', '/ygst/pc/exception/year/count/get', params)
  },
  /**
   * /ygst/pc/device/count/get 根据组织ID统计监管设备
   * @param orgId
   * @param year
   */
  deviceCountGet: ({year, orgId}) => {
    let params = {
      year,
      orgId
    }
    return post('swaggerSB', '/ygst/pc/device/count/get', params)
  },
  /**
   * /ygst/pc/device/resource/count/get 根据组织ID统计监管设备资源信息
   * @param orgId
   * @param year
   */
  deviceResCountGet: ({year, orgId}) => {
    let params = {
      year,
      orgId
    }
    return post('swaggerSB', '/ygst/pc/device/resource/count/get', params)
  },
  /**
   * /ygst/pc/device/resource/percentage/get 根据组织ID获取监管设备资源分配信息
   * @param orgId
   * @param year
   */
  deviceResPerGet: ({year, orgId}) => {
    let params = {
      year,
      orgId
    }
    return post('swaggerSB', '/ygst/pc/device/resource/percentage/get', params)
  },
  /**
   * /ygst/pc/exception/dept/list 统计组织下各部门/食堂的异常信息
   * @param orgId
   * @param year
   */
  exceptionDeptList: ({year, orgId}) => {
    let params = {
      year,
      orgId
    }
    return post('swaggerSB', '/ygst/pc/exception/dept/list', params)
  },
  /**
   * /ygst/pc/health/people/count/get 各食堂人员分布情况统计
   * @param orgId
   * @param year
   */
  peopleCountGet: ({year, orgId}) => {
    let params = {
      year,
      orgId
    }
    return post('swagger', '/ygst/pc/health/people/count/get', params)
  },
  /**
   * /ygst/exception/report/dept/list 报表数据中心-统计组织下各部门/食堂的异常信息（wzp）
   * @param beginTime
   * @param endTime
   * @param orgId
   */
  exReportDeptList: ({endTime, beginTime, orgId}) => {
    let params = {
      endTime,
      beginTime,
      orgId
    }
    return post('swaggerSB', '/ygst/exception/report/dept/list', params)
  },
  /**
   * /ygst/exception/report/export/dept/list 报表数据中心-统计组织下各部门/食堂的异常信息(导出Excel)（wzp）
   * @param beginTime
   * @param endTime
   * @param orgId
   */
  exReportExport: ({endTime, beginTime, orgId}) => {
    let params = {
      endTime,
      beginTime,
      orgId
    }
    return post('swaggerSB', '/ygst/exception/report/export/dept/list', params)
  },
  /**
   * /ygst/exception/report/deptdetailtype/list 报表数据中心-统计组织下食堂的详情异常类型（wzp）
   * @param beginTime
   * @param endTime
   * @param orgId
   */
  reportDeptdetailtypeList: ({endTime, beginTime, orgId}) => {
    let params = {
      endTime,
      beginTime,
      orgId
    }
    return post('swaggerSB', '/ygst/exception/report/deptdetailtype/list', params)
  },
  /**
   * /ygst/exception/report/export/deptdetailtype/list 统计组织下食堂的详情异常类型(导出Excel)（wzp）
   * @param beginTime
   * @param endTime
   * @param orgId
   */
  exportDeptdetailtypeList: ({endTime, beginTime, orgId}) => {
    let params = {
      endTime,
      beginTime,
      orgId
    }
    return post('swaggerSB', '/ygst/exception/report/export/deptdetailtype/list', params)
  },
  /**
   * /ygst/pc/device/report/monitor/get 报表数据中心-监管设备（wzp)
   * @param beginTime
   * @param endTime
   * @param orgId
   */
  reportMonitorGet: ({endTime, beginTime, orgId}) => {
    let params = {
      endTime,
      beginTime,
      orgId
    }
    return post('swaggerSB', '/ygst/pc/device/report/monitor/get', params)
  },
  /**
   * /ygst/pc/device/report/export/monitor/get 统计组织下食堂的详情异常类型(导出Excel)（wzp）
   * @param beginTime
   * @param endTime
   * @param orgId
   */
  reportExportMonitorGet: ({endTime, beginTime, orgId}) => {
    let params = {
      endTime,
      beginTime,
      orgId
    }
    return post('swaggerSB', '/ygst/pc/device/report/export/monitor/get', params)
  },
  /**
   * @Description:根据fileId获取文件地址
   * @param fileId
   * @param interfaceType
  */
  getDownloadUrl: (fileId, interfaceType) => {
    console.log('!!!!', interfaceType, fileId)
    if (interfaceType === 'workflow') {
      return post('workflow', 'ehome.workflow.attachment.download.url.get', {
        'attachmentId': fileId
      })
    } else if (interfaceType === 'job') {
      console.log('!!!!222', interfaceType, fileId)
      return post('workflow', 'ehome.workflow.job.attachment.get', {
        'attachmentId': fileId
      })
    } else {
      return post('outer', 'ehome.org.file.download.url.get', {
        'fileId': fileId
      })
    }
  },
  /**
   * /ygst/exception/report/monthtrend/list 报表数据中心-月度异常趋势统计（wzp）
   * @param year
   * @param orgId
   */
  reportMonthtrendList: ({year, orgId}) => {
    let params = {
      year,
      orgId
    }
    return post('swaggerSB', '/ygst/exception/report/monthtrend/list', params)
  },
  /**
   * /ygst/exception/report/export/monthtrend/list 报表数据中心-月度异常趋势统计(导出Excel)（wzp）
   * @param year
   * @param orgId
   */
  exportMonthtrendList: ({year, orgId}) => {
    let params = {
      year,
      orgId
    }
    return post('swaggerSB', '/ygst/exception/report/export/monthtrend/list', params)
  },
  /**
   * /ygst/pc/device/report/export/resource/get 报表数据中心-监管资源统计(导出Excel)（wzp)
   * @param year
   * @param orgId
   */
  exportResourceGet: ({year, orgId}) => {
    let params = {
      year,
      orgId
    }
    return post('swaggerSB', '/ygst/pc/device/report/export/resource/get', params)
  },
  /**
   * /ygst/pc/device/report/resource/get 报表数据中心-监管资源统计（wzp)
   * @param year
   * @param orgId
   */
  reportResourceGet: ({year, orgId}) => {
    let params = {
      year,
      orgId
    }
    return post('swaggerSB', '/ygst/pc/device/report/resource/get', params)
  },
  /**
   * /ygst/exception/report/deptnum/list 报表数据中心-异常食堂分布（wzp）
   * @param beginTime
   * @param endTime
   * @param orgId
   */
  reportDeptnumList: ({endTime, beginTime, orgId}) => {
    let params = {
      endTime,
      beginTime,
      orgId
    }
    return post('swaggerSB', '/ygst/exception/report/deptnum/list', params)
  },
  /**
   * /ygst/exception/report/export/deptnum/list 报表数据中心-异常食堂分布（wzp）
   * @param beginTime
   * @param endTime
   * @param orgId
   */
  exportReportDeptnumList: ({endTime, beginTime, orgId}) => {
    let params = {
      endTime,
      beginTime,
      orgId
    }
    return post('swaggerSB', '/ygst/exception/report/export/deptnum/list', params)
  },
  /**
   * /ygst/pc/health/report/people/count/get 各食堂人员分布情况统计
   * @param year
   * @param orgId
   */
  healthPeopleCountGet: ({year, orgId}) => {
    let params = {
      year,
      orgId
    }
    return post('swagger', '/ygst/pc/health/report/people/count/get', params)
  },
  /**
   * /ygst/pc/health/export/people/count/get 报表中心-各食堂人员分布情况统计（导出Excel）（wzp）
   * @param year
   * @param orgId
   */
  exportHealthPeopleCountGet: ({year, orgId}) => {
    let params = {
      year,
      orgId
    }
    return post('swagger', '/ygst/pc/health/export/people/count/get', params)
  },
  /**
   * /ygst/canteenRource/report/nocheckstatistics/get 报表中心-日巡查清单异常情况(wzp)
   * @param beginTime
   * @param endTime
   * @param orgId
   */
  reportNocheckGet: ({endTime, beginTime, orgId}) => {
    let params = {
      endTime,
      beginTime,
      orgId
    }
    return post('swagger', '/ygst/canteenRource/report/nocheckstatistics/get', params)
  },
  /**
   * /ygst/canteenRource/report/export/nocheckstatistics/get 报表中心-日巡查清单异常情况(导出Excel)(wzp)
   * @param beginTime
   * @param endTime
   * @param orgId
   */
  exportNocheckGet: ({endTime, beginTime, orgId}) => {
    let params = {
      endTime,
      beginTime,
      orgId
    }
    return post('swagger', '/ygst/canteenRource/report/export/nocheckstatistics/get', params)
  },
  /**
   * /ygst/exception/report/export/nogoodtype/list 报表数据中心-异常类别分类（无食品）(导出Excel)（wzp）
   * @param year
   * @param orgId
   */
  exportNogoodtypeList: ({year, orgId}) => {
    let params = {
      year,
      orgId
    }
    return post('swaggerSB', '/ygst/exception/report/export/nogoodtype/list', params)
  },
  /**
   * /ygst/exception/report/nogoodtype/list 报表数据中心-异常类别分类（无食品）（wzp）
   * @param year
   * @param orgId
   */
  reportNogoodtypeList: ({year, orgId}) => {
    let params = {
      year,
      orgId
    }
    return post('swaggerSB', '/ygst/exception/report/nogoodtype/list', params)
  },
  /**
   * /ygst/pc/device/totalreport/resource/get 报表数据中心-总体报表-监控设备资源（wzp)
   * @param year
   * @param orgId
   */
  totalreportResourceGet: ({year, orgId}) => {
    let params = {
      year,
      orgId
    }
    return post('swaggerSB', '/ygst/pc/device/totalreport/resource/get', params)
  },
  /**
   * /ygst/exception/report/export/total/get 报表数据中心-总体报表-监控设备资源（wzp)
   * @param year
   * @param orgId
   */
  exportTotalGet: ({year, orgId}) => {
    let params = {
      year,
      orgId
    }
    return post('swaggerSB', '/ygst/exception/report/export/total/get', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/Statistics.js